<template>
  <div
    class="w-full h-full mt-1 dot-wrapper"
    :class="index === last-1 && 'mr-0'"
    :style="active === index ? 'border-color:#0384FB' : 'border-color:#979797;'"
  >
    <div
      class="w-full h-full flex justify-center align-middle"
      @click="$emit('clicked')"
    >
      <PictureWrapper
        v-if="slide?.sys?.contentType?.sys?.id === 'image'"
        :image="slide?.fields"
        class="w-full h-full object-cover flex justify-center align-middle"
        :custom-scale="'?fit=fill&w=80&h=80&fm=jpg'"
      />
      <div
        v-else-if="slide?.sys?.contentType?.sys?.id === 'video'"
        class="tile--video h-full w-full relative"
        @click="toggleModal"
      >
        <img
          v-if="slide?.fields?.coverImage"
          class="w-full h-full object-cover"
          :src="slide?.fields?.coverImage?.fields?.file?.url"
          alt="yt thumbnail"
        />
        <img
          v-else
          class="w-full h-full object-cover"
          :src="`https://img.youtube.com/vi/${slide.fields.id}/hqdefault.jpg`"
          alt="yt thumbnail"
        />
        <svg
          width="37"
          height="37"
          viewBox="0 0 37 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="absolute"
        >
          <circle cx="18.5" cy="18.5" r="18.5" fill="#0384FB" />
          <path
            d="M23.1868 18.2532L15.7868 22.5255L15.7868 13.9808L23.1868 18.2532Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
    <Modal
      v-if="slide?.sys?.contentType?.sys?.id === 'video'"
      :is-open="openModal"
      close-location="outer"
      bg="bg-transparent"
      @close="toggleModal"
    >
      <div class="w-full m-auto position-fixed z-50 modal__content">
        <Video v-if="openModal" :video="slide?.fields" />
      </div>
    </Modal>
  </div>
</template>
<style lang="scss" scoped>
::v-deep .tile--video {
  svg,
  img {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.modal--row {
  background: rgba(0, 0, 0, 0.5);
}

::v-deep .modal__inner {
  top: 68% !important;
}

::v-deep .modal__content {
  iframe {
    width: 100%;
    height: 480px;
    z-index: 50;
  }
  transform: translateY(50%);

  @media (min-width: 1000px) {
    width: 60vw;
    transform: translateY(0%);

    ::v-deep .video,
    .aspect--16x9,
    iframe {
      width: 100%;
      height: 480px;
      width: 853px;
      max-width: 853px;
      z-index: 50;
    }
  }
}
.dot-wrapper {
  @media (max-width: 736px) {
    width: 80px !important;
    min-width: 80px;
    height: 80px !important;
    margin-top: 0;
  }
}
</style>
<script>
import PictureWrapper from "./PictureWrapper";
import Video from "./Video";
import Modal from "../Modal";

export default {
  components: {
    PictureWrapper,
    Modal,
    Video
  },
  props: {
    slide: {
      type: Object,
      required: true
    },
    index: {
      type: [String, Number],
      required: true
    },
    active: {
      type: Number,
      required: true
    },
    last: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      openModal: false
    };
  },
  methods: {
    toggleModal() {
      this.openModal = !this.openModal;
    }
  }
};
</script>
